import { defineComponent } from 'vue';
import { RouteLocationNormalizedLoaded as Route } from 'vue-router';
import openModal from '@/components/modal';
import PostModal from './PostModal.vue';

export default defineComponent({
  watch: {
    $route: {
      handler(to: Route) {
        if (to.query.postId) {
          const postId = parseInt((to.query.postId as string), 10);
          openModal(PostModal, { parent: this, postId });
        }
      },
      immediate: true,
    },
  },
});
